export enum RouteKeys {
  Auth = '/auth',
  Login = '/auth/login',
  Signup = '/signup',
  SignupOtp = '/signup/otp',
  SignupOnboard = '/signup/onboard',
  SignupThankYou = '/signup/thank-you',
  Home = '/',
  Dashboard = '/dashboard',
  ForgotPassword = '/auth/forgot-password',
  ResetPasswordWithOTP = '/auth/forgot-password/otp',
  Payment = '/dashboard/payment',
  PaymentCallback = '/payment/redirect',
  NotFound = '/page-not-found',
  LectureVideo = '/lecture-video/:lessonId/:topicId/:subTopicId',
  ScheduleDetails = '/schedules/:scheduleId',
  QuestionAnswer = '/question-answer/:lessonId/:topicId/quiz',
  PdfInvoice = '/invoice/:id/pdf/',
  LumpsumPdfInvoice = '/lumpsum-invoice/pdf/',
  PdfContract = '/contract/:id/pdf/',
  Dev = '/dev/',
  PdfRefundDocument = '/refund-document/:id/pdf/',
  PdfClearanceCertificate = '/clearance-certificate/:id/pdf/',
  BookAppointment = '/book-an-appointment',
  BookAppointmentThankYou = '/book-an-appointment/thank-you',
  PaymentThankYou = '/dashboard/payment/thank-you',
  CustomerFeedback = '/customer-feedback',
  CustomerFeedbackThankYou = '/customer-feedback-thank-you',
  CorporateLumpsumPdfInvoice = '/corporate-lumpsum-invoice/pdf/',
  CorporatePdfInvoice = '/corporate-invoice/pdf/',
  PdfRefundDocumentCorporate = '/corporate-refund-document/:id/pdf/',
  PreregistrationPdfInvoice = '/preregistration-invoice/:id/pdf/',
  MyReferrals = '/dashboard/my-referral-report/:id/',
  CollectionReportPdf = '/collection-report/pdf/',
  SalesmanCollectionReport = '/saleman-collection-report/pdf/',
  SalesmanCollectingReport = '/saleman-collecting-report/pdf/',
  SalesmanAllCollectionReport = '/saleman-all-collection-report/pdf/',
  SignupOnlinePayment = '/signup/payment',
  PaymentError = '/dashboard/payment/error',
  OnlinePaymentRedirect = '/online-payment/redirect',
  SignupOnlinePaymentRedirect = '/signup/payment/redirect',
  PaymentRequestPage = '/payment-request/:id',
  OnlinePaymentRedirectForLink = '/payment/redirectLink',
  PaymentErrorLink = '/dashboard/paymentlink/error',
  PaymentCancelledLink = '/dashboard/paymentlink/cancelled',
  PaymentThankYouLink = '/dashboard/paymentlink/success',
}
